module.exports = __webpack_public_path__ + "img/Frame5.87f7149b.png";